var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#DFE6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3333 28.25V26.4167C27.3333 25.4442 26.947 24.5116 26.2593 23.8239C25.5717 23.1363 24.6391 22.75 23.6666 22.75H16.3333C15.3608 22.75 14.4282 23.1363 13.7406 23.8239C13.0529 24.5116 12.6666 25.4442 12.6666 26.4167V28.25",
    stroke: "#444653",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.0833C22.0251 19.0833 23.6667 17.4417 23.6667 15.4167C23.6667 13.3916 22.0251 11.75 20 11.75C17.975 11.75 16.3334 13.3916 16.3334 15.4167C16.3334 17.4417 17.975 19.0833 20 19.0833Z",
    stroke: "#444653",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarUser);
export default __webpack_public_path__ + "static/media/sidebar_user.0f67586912d6b8b0f81c79b64a1cdd30.svg";
export { ForwardRef as ReactComponent };